<template>
  <div class="container">
    <div class="auth">
      <div class="auth-form">
        <card>
          <div class="text-center mb-4 mt-4">
            <img round width="110" src="@/assets/img/logo.svg" alt="" />
          </div>
          <set-language class="dark" />
          <component :is="state" v-model="state" />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
import SetLanguage from "@/components/SetLanguage";

export default {
  name: "auth",
  components: {
    login: () => import("@/components/Auth/Login"),
    SetLanguage,
  },
  mounted() {},
  data() {
    return {
      state: "login",
      states: {
        login: {
          title: "Вход в систему",
          key: "login",
        },
      },
    };
  },
  methods: {},
};
</script>
<style lang="scss">
.auth {
  &-form {
    max-width: 380px;
    width: 100%;
    margin: 4em auto 3.5em;
  }
}
</style>
